import { makeAutoObservable } from "mobx";
import { Availability } from "../Availability";
/**
 * Represents the customer making the order.
 */
export class OrderReceiver {
    constructor(params) {
        this.invoiceRequest = params.invoiceRequest;
        this.contactDetails = params.contactDetails;
        this.consents = params.consents;
        makeAutoObservable(this);
    }
    get invoiceAvailability() {
        return this.invoiceRequest
            ? this.invoiceRequest.availability
            : Availability.available();
    }
    get availability() {
        return Availability.composite([
            this.contactDetails.availability,
            this.consents.availability,
            this.invoiceAvailability,
        ]);
    }
    get checkoutData() {
        return {
            customer: {
                ...this.contactDetails.checkoutData,
                ...this.consents.checkoutData,
            },
            vatId: this.invoiceRequest !== null
                ? this.invoiceRequest.checkoutData.vatId
                : null,
        };
    }
}
